// Build Systainer Rack JS

$(document).ready(function() {


    // ============================================
    // Config Variant ID Tracker
    // ============================================
    try {
        // Check if main variant selects exists
        const mainVariantSelects = document.querySelector('.product__info-container > variant-selects');
        if (!mainVariantSelects) {
            console.log('Config Variant Tracker: Main variant selects not found');
            return;
        }
        
        // Check if configuration container exists
        const configContainer = document.querySelector('.cstm_rack_prd_container');
        if (!configContainer) {
            console.log('Config Variant Tracker: Configuration container not found');
            return;
        }
        
        // Check if configuration variant selects exists
        const configVariantSelects = configContainer.querySelector('variant-selects.cstm_rack_configure_main_prd_variants');
        if (!configVariantSelects) {
            console.log('Config Variant Tracker: Configuration variant selects not found');
            return;
        }
        
        // Check if JSON script exists
        const jsonScript = configVariantSelects.querySelector('script[type="application/json"]');
        if (!jsonScript) {
            console.log('Config Variant Tracker: JSON script not found');
            return;
        }
        
        // Parse configuration variants
        let configVariants = [];
        try {
            const parsed = JSON.parse(jsonScript.textContent);
            if (Array.isArray(parsed)) {
                if (parsed.length > 0 && parsed[0] === "") {
                    configVariants = parsed.slice(1);
                } else {
                    configVariants = parsed;
                }
            }
            
            if (!configVariants || configVariants.length === 0) {
                console.log('Config Variant Tracker: No variants found in JSON data');
                return;
            }
            
            console.log('Config Variant Tracker: Loaded', configVariants.length, 'configuration variants');
        } catch(e) {
            console.error('Config Variant Tracker: Error parsing JSON:', e);
            return;
        }
        
        // Function to get selected options from main product page
        function getSelectedOptionsFromMain() {
            try {
                const selectedValues = [];
                const fieldsets = mainVariantSelects.querySelectorAll('fieldset');
                
                if (!fieldsets || fieldsets.length === 0) {
                    return selectedValues;
                }
                
                fieldsets.forEach(fieldset => {
                    // Try to get selected value from legend span
                    const legendSpan = fieldset.querySelector('legend span');
                    if (legendSpan && legendSpan.textContent) {
                        let value = legendSpan.textContent.trim();
                        value = value.replace(/\u00A0/g, ' ').trim();
                        if (value) {
                            selectedValues.push(value);
                            return;
                        }
                    }
                    
                    // Fallback: get from checked radio
                    const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
                    if (checkedRadio && checkedRadio.value) {
                        selectedValues.push(checkedRadio.value);
                        return;
                    }
                    
                    // Another fallback: get from legend text after colon
                    const legend = fieldset.querySelector('legend');
                    if (legend && legend.textContent) {
                        const legendText = legend.textContent;
                        const colonIndex = legendText.indexOf(':');
                        if (colonIndex !== -1) {
                            let value = legendText.substring(colonIndex + 1).trim();
                            value = value.replace(/\u00A0/g, ' ').trim();
                            if (value) {
                                selectedValues.push(value);
                            }
                        }
                    }
                });
                
                return selectedValues;
            } catch(e) {
                console.error('Config Variant Tracker: Error getting selected options:', e);
                return [];
            }
        }
        
        // Function to find matching variant in configuration data
        function findMatchingVariant(selectedOptions) {
            try {
                if (!selectedOptions || selectedOptions.length !== 3) {
                    return null;
                }
                
                if (!configVariants || configVariants.length === 0) {
                    return null;
                }
                
                const match = configVariants.find(variant => {
                    return variant && 
                           variant.option1 === selectedOptions[0] &&
                           variant.option2 === selectedOptions[1] &&
                           variant.option3 === selectedOptions[2];
                });
                
                return match || null;
            } catch(e) {
                console.error('Config Variant Tracker: Error finding matching variant:', e);
                return null;
            }
        }
        
        // Variable to store the current matching variant ID
        let currentConfigVariantId = null;
        let currentVariantData = null;
        
        // Function to update and store the variant ID
        function updateConfigVariantId() {
            try {
                const selectedOptions = getSelectedOptionsFromMain();
                
                if (selectedOptions && selectedOptions.length === 3) {
                    const matchingVariant = findMatchingVariant(selectedOptions);
                    
                    if (matchingVariant && matchingVariant.id) {
                        const previousId = currentConfigVariantId;
                        currentConfigVariantId = matchingVariant.id;
                        currentVariantData = matchingVariant;
                        
                        // Only log if changed
                        if (previousId !== currentConfigVariantId) {
                            console.log('Config Variant Tracker: Updated to ID', currentConfigVariantId);
                            document.querySelector('.product-variant-id').value = currentConfigVariantId;
                        }
                        
                        // Dispatch custom event for other scripts
                        if (typeof window !== 'undefined') {
                            window.dispatchEvent(new CustomEvent('configVariantUpdated', {
                                detail: {
                                    variantId: currentConfigVariantId,
                                    variantData: currentVariantData,
                                    selectedOptions: selectedOptions
                                }
                            }));
                        }
                        
                        // Optional: Update hidden input field if exists
                        const hiddenInput = document.querySelector('#config-variant-id-input');
                        if (hiddenInput) {
                            hiddenInput.value = currentConfigVariantId;
                        }
                        
                        return currentConfigVariantId;
                    } else {
                        currentConfigVariantId = null;
                        currentVariantData = null;
                        return null;
                    }
                } else {
                    currentConfigVariantId = null;
                    currentVariantData = null;
                    return null;
                }
            } catch(e) {
                console.error('Config Variant Tracker: Error updating variant ID:', e);
                currentConfigVariantId = null;
                currentVariantData = null;
                return null;
            }
        }
        
        // Add event listeners to variant options on main product page
        try {
            const variantOptions = mainVariantSelects.querySelectorAll('input[type="radio"], .cstm_swatch_color');
            
            if (variantOptions && variantOptions.length > 0) {
                variantOptions.forEach(option => {
                    if (!option) return;
                    
                    // Click event for swatches and radios
                    option.addEventListener('click', () => {
                        setTimeout(() => {
                            updateConfigVariantId();
                        }, 100);
                    });
                    
                    // Change event specifically for radio buttons
                    if (option.tagName === 'INPUT' && option.type === 'radio') {
                        option.addEventListener('change', () => {
                            setTimeout(() => {
                                updateConfigVariantId();
                            }, 100);
                        });
                    }
                });
            }
        } catch(e) {
            console.error('Config Variant Tracker: Error adding event listeners:', e);
        }
        
        // Initial update
        setTimeout(() => {
            updateConfigVariantId();
        }, 500);
        
        // Make functions available globally with safe check
        if (typeof window !== 'undefined') {
            window.getConfigVariantId = function() {
                return currentConfigVariantId;
            };
            
            window.getCurrentConfigVariantData = function() {
                return currentVariantData;
            };
            
            window.refreshConfigVariantId = function() {
                return updateConfigVariantId();
            };
        }
        
        console.log('Config Variant Tracker: Initialized successfully');
        
    } catch(e) {
        // Catch any unexpected errors to prevent breaking existing functionality
        console.error('Config Variant Tracker: Fatal error -', e);
    }



   if ($('.cstm_rack_prd_container').length > 0) {
      // Get the product JSON
      const productData = JSON.parse($('.cstm_rack_prd_container variant-selects.cstm_rack_configure_prd_variants script[type="application/json"]').html());
      
      // Get the product heading dynamically
      const productHeading = $('.cstm_rack_prd_container .cstm_rack_configure_prd_variants h5').text().trim();
      
      // Function to extract unique option values
      function extractUniqueOptions(productData, optionIndex) {
        const options = new Set();
        
        $.each(productData, function(index, variant){
          if(!variant.id) return;
          
          const variantTitle = variant.public_title || '';
          const optionParts = variantTitle.split('/').map(part => part.trim());
          
          if (optionParts[optionIndex]) {
            options.add(optionParts[optionIndex]);
          }
        });
        
        return Array.from(options).sort();
      }
      
      // Function to create option swatch section
      function createOptionSwatchSection(title, optionValues, productData, optionType, isConfiguration = false) {
        const sectionWrapper = $('<div class="option-swatch-section"></div>');
        const originalTitle = title + ':';
        const sectionHeading = $(`<h6 class="option-section-heading">${originalTitle}<span></span></h6>`);
        sectionWrapper.append(sectionHeading);
        
        const swatchWrapper = $('<div class="option-swatch-wrapper"></div>');
        
        // Create swatch for each option value
        optionValues.forEach(optionValue => {
          // Find first available variant with this option value
          let sampleVariant = null;
          $.each(productData, function(index, variant){
            if(!variant.id) return;
            
            const variantTitle = variant.public_title || '';
            const optionParts = variantTitle.split('/').map(part => part.trim());
            
            if (optionType === 'body' && optionParts[0] === optionValue) {
              sampleVariant = variant;
              return false;
            } else if (optionType === 'catch' && optionParts[1] === optionValue) {
              sampleVariant = variant;
              return false;
            }
          });
          
          if (sampleVariant) {
            // Create the file name
            const variantFile = optionValue.replace(/ /g, '_') + '.png';
            const bgStyle = `background-image: url('/cdn/shop/files/${variantFile}');`;
            
            // Create swatch div
            const swatchDiv = $('<div class="option-swatch cstm_swatch_color"></div>')
              .attr('data-option-type', optionType)
              .attr('data-option-value', optionValue)
              .attr('title', optionValue)
              .attr('style', bgStyle);
            
            if(!sampleVariant.available){
              swatchDiv.addClass('out-of-stock');
            }
            
            // Append to wrapper
            swatchWrapper.append(swatchDiv);
          }
        });
        
        sectionWrapper.append(swatchWrapper);
        return sectionWrapper;
      }
      
      // Function to create combined swatches (original logic for main container)
      function createCombinedSwatchContainer(productHeading, productData) {
        const combinedWrapper = $('<div class="combined-variant-wrapper"></div>');
        const combinedHeading = $(`<h6 class="combined-variant-heading">${productHeading} BODY & CATCH COLOR:&nbsp;&nbsp;&nbsp;&nbsp;<span></span></h6>`);
        combinedWrapper.append(combinedHeading);
        
        const swatchWrapper = $('<div class="combined-swatch-wrapper"></div>');
        
        const addedColors = new Set();
        
        $.each(productData, function(index, variant){
          if(!variant.id) return;
          
          const variantTitle = variant.public_title || '';
          const variantId = variant.id;
          const isAvailable = variant.available;
          
          const colorParts = variantTitle.split('/').map(part => part.trim());
          
          if (colorParts.length >= 2 && colorParts[0] === colorParts[1]) {
            const matchedColor = colorParts[0];
            
            if (addedColors.has(matchedColor)) {
              return;
            }
            
            addedColors.add(matchedColor);
            
            const variantFile = matchedColor.replace(/ /g, '_') + '.png';
            const bgStyle = `background-image: url('/cdn/shop/files/${variantFile}');`;
            
            const swatchDiv = $('<div class="combined-swatch cstm_swatch_color"></div>')
              .attr('data-variant-id', variantId)
              .attr('data-color-name', matchedColor)
              .attr('title', matchedColor)
              .attr('style', bgStyle);
            
            if(!isAvailable){
              swatchDiv.addClass('out-of-stock');
            }
            
            swatchWrapper.append(swatchDiv);
          }
        });
        
        if (addedColors.size === 0) {
          $.each(productData, function(index, variant){
            if(!variant.id) return;
            
            const variantTitle = variant.public_title || '';
            const variantId = variant.id;
            const isAvailable = variant.available;
            
            const variantFile = variantTitle.replace(/ /g, '_') + '.png';
            const bgStyle = `background-image: url('/cdn/shop/files/${variantFile}');`;
            
            const swatchDiv = $('<div class="combined-swatch"></div>')
              .attr('data-variant-id', variantId)
              .attr('title', variantTitle)
              .attr('style', bgStyle);
            
            if(!isAvailable){
              swatchDiv.addClass('out-of-stock');
            }
            
            swatchWrapper.append(swatchDiv);
          });
        }
        
        combinedWrapper.append(swatchWrapper);
        return combinedWrapper;
      }
      
      // Create and append swatches to main container
      const mainSwatches = createCombinedSwatchContainer(productHeading, productData);
      $('.cstm_rack_prd_container').append(mainSwatches);
      // $('.cstm_rack_prd_container').append(`<a class="cstm_customize_rack" href="#">Customize Your Rack & S76 Further</a>`);
      
      // Function to handle swatch selection for main container
      function setupMainSwatchSelection(swatchContainer) {
        const headingText = swatchContainer.find('.combined-variant-heading').text().split('<span>')[0];
        
        swatchContainer.find('.combined-swatch').on('click', function(){
          swatchContainer.find('.combined-swatch').removeClass('selected');
          $(this).addClass('selected');
          
          const selectedId = $(this).data('variant-id');
          console.log('Selected Variant ID:', selectedId);
          
          $('.cstm_rack_prd_container').attr('data-selected-variant', selectedId);

          var clickColor = $(this).attr('data-color-name');
          swatchContainer.find('.combined-variant-heading span').text(` ${clickColor}`);
        });
        
        if (swatchContainer.find('.combined-swatch').length > 0) {
          swatchContainer.find('.combined-swatch').first().trigger('click');
          swatchContainer.find('.combined-swatch[title="Light Grey"]').attr('data-variant-id', '44533692760215');
        }
      }
      
      setupMainSwatchSelection($('.cstm_rack_prd_container .combined-variant-wrapper'));
      
      // Function to find variant by selected options
      function findVariantByOptions(bodyColor, catchColor, productData) {
        let foundVariant = null;
        
        $.each(productData, function(index, variant){
          if(!variant.id) return;
          
          const variantTitle = variant.public_title || '';
          const optionParts = variantTitle.split('/').map(part => part.trim());
          
          if (optionParts[0] === bodyColor && optionParts[1] === catchColor) {
            foundVariant = variant;
            return false; // break the loop
          }
        });
        
        return foundVariant;
      }
      
      // Global variables for configuration
      let selectedBodyColor = null;
      let selectedCatchColor = null;
      let selectedVariantId = null;
      
      // Function to manually select a swatch (for default selection)
      function manuallySelectSwatch($swatch) {
        if (!$swatch || $swatch.length === 0) return;
        
        const section = $swatch.closest('.option-swatch-section');
        const isBodyColor = $swatch.attr('data-option-type') === 'body';
        const selectedValue = $swatch.attr('data-option-value');
        
        // Remove selected class from all swatches in this section
        section.find('.option-swatch').removeClass('selected');
        
        // Add selected class to clicked swatch
        $swatch.addClass('selected');
        
        // Update selected value
        if (isBodyColor) {
          selectedBodyColor = selectedValue;
        } else {
          selectedCatchColor = selectedValue;
        }
        
        // Update heading span
        section.find('.option-section-heading span').text(` ${selectedValue}`);
        
        console.log(`Manually selected ${isBodyColor ? 'Body' : 'Catch'} Color:`, selectedValue);
      }
      
      // Function to update configuration
      function updateConfiguration() {
        if (selectedBodyColor && selectedCatchColor) {
          // Find the matching variant
          const variant = findVariantByOptions(selectedBodyColor, selectedCatchColor, productData);
          
          if (variant) {
            selectedVariantId = variant.id;
            
            // Set data-variant-id attribute on the wrapper
            $('.cstm_rack_configure_wrapper_details').attr('data-selected-variant', selectedVariantId);
            
            console.log('Selected Variant:', variant.id, variant.public_title);
          } else {
            // Remove variant ID if combination not found
            $('.cstm_rack_configure_wrapper_details').removeAttr('data-selected-variant');
          }
        }
      }
      
      // Function to handle swatch clicks in configuration
      function handleConfigSwatchClick() {
        const $swatch = $(this);
        const section = $swatch.closest('.option-swatch-section');
        const isBodyColor = $swatch.attr('data-option-type') === 'body';
        
        // Remove selected class from all swatches in this section
        section.find('.option-swatch').removeClass('selected');
        
        // Add selected class to clicked swatch
        $swatch.addClass('selected');
        
        // Update selected value
        const selectedValue = $swatch.attr('data-option-value');
        
        if (isBodyColor) {
          selectedBodyColor = selectedValue;
        } else {
          selectedCatchColor = selectedValue;
        }
        
        // Update heading span
        section.find('.option-section-heading span').text(` ${selectedValue}`);
        
        // Update configuration
        updateConfiguration();
      }

      $(document).on('click', '.cstm_customize_rack', function(e) {
        e.preventDefault();
        $('.product-form__quantity, .custom_btn_buy, .large-project-contact, .thumbnail-slider, .cstm_rack_prd_container').addClass('cstm_hide');
        $('.cstm_rack_configure_wrapper_new_inner').addClass('active');
        $('.cstm_rack_configure_wrapper_new_inner_atc').addClass('active');
        $('.ps-accordion-container').addClass('cstm_hide');
      });

      $(document).on('click', '.cstm_rack_configure_wrapper_close_btn', function(e) {
        e.preventDefault();
        $('.product-form__quantity, .custom_btn_buy, .large-project-contact, .thumbnail-slider, .cstm_rack_prd_container').removeClass('cstm_hide');
        $('.cstm_rack_configure_wrapper_new_inner').removeClass('active');
        $('.cstm_rack_configure_wrapper_new_inner_atc').removeClass('active');
        $('.ps-accordion-container').removeClass('cstm_hide');
      });

      // AUTO-OPEN CUSTOMIZE MODE ON PAGE LOAD (replaces the "Customize Your Rack" button)
      $('.product-form__quantity, .custom_btn_buy, .large-project-contact, .thumbnail-slider, .cstm_rack_prd_container').addClass('cstm_hide');
      $('.cstm_rack_configure_wrapper_new_inner').addClass('active');
      $('.cstm_rack_configure_wrapper_new_inner_atc').addClass('active');
      $('.ps-accordion-container').addClass('cstm_hide');

      $(document).on('click', '.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div', function(event) {

        // UNCHECK APPLY-TO-ALL CHECKBOX WHEN USER CLICKS ANY DIV
        const $applyToAllCheckbox = $('#apply-to-all');
        if ($applyToAllCheckbox.is(':checked')) {
            $applyToAllCheckbox.prop('checked', false);
        }

        const $div = $(this);
        
        // Check if this div already has product data (has configured-active class OR data-variant-id)
        const hasProductData = $div.hasClass('configured-active') || $div.attr('data-variant-id');
        
        if (hasProductData) {
          // This div already has product data, don't show configuration panel
          // Ensure the plus image is properly hidden
          $div.find('> img').css('display', 'none');
          $div.find('> span').addClass('cstm_hide');
          return; // Exit early
        }
        
        // Original behavior for non-configured items
        $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div').removeClass('active');
        $div.addClass('active');
        
        // Hide all plus images and show only for active div
        $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div > img').each(function() {
          const $thisImg = $(this);
          const $parentDiv = $thisImg.parent('div');
          
          // Only show if the parent div doesn't have product data
          const parentHasProductData = $parentDiv.hasClass('configured-active') || $parentDiv.attr('data-variant-id');
          if (!parentHasProductData) {
            $thisImg.css('display', 'block');
          }
        });
        
        // Hide the clicked image
        $div.find('> img').css('display', 'none');
        
        // Update text
        $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div > span').text('Add an s 76 to configure');
        $div.find('> span').text('Configuring your S 76').removeClass('cstm_hide');
        
        $('.cstm_rack_configure_wrapper_new_inner_main_flexitem2_span').addClass('cstm_hide');
        $('.cstm_rack_configure_wrapper_details').addClass('active');
        
        // Activate the first variant selector
        $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').removeClass('is-active');
        $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').first().addClass('is-active');
      });

      $(document).on('click', '.cstm_rack_configure_wrapper_details .rack-option', function(e) {
          e.preventDefault();
          $('.cstm_rack_configure_wrapper_details .rack-option').removeClass('is-active');
          $(this).addClass('is-active');
          var clickedPrdHandle = $(this).attr('data-product-handle');
          $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').removeClass('is-active');
          $(`.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants[data-product-handle="${clickedPrdHandle}"]`).addClass('is-active');
          updateTitleSpan();
          
          // ADD THESE LINES - Re-initialize selection and update spans for the newly activated product
          setTimeout(function() {
              const $activeVariantSelects = $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants.is-active');
              if ($activeVariantSelects.length) {
                  // Re-run initialization for just this variant selects
                  $activeVariantSelects.find('fieldset').each(function() {
                      const $fieldset = $(this);
                      const $checkedInput = $fieldset.find('input[type="radio"]:checked');
                      
                      if (!$checkedInput.length) {
                          const $firstEnabledWrapper = $fieldset.find('.cstm_var_sel_wrapper:not(.disabled)').first();
                          if ($firstEnabledWrapper.length) {
                              const $input = $firstEnabledWrapper.find('input[type="radio"]');
                              $input.prop('checked', true);
                              const optionName = $input.attr('name');
                              const baseOptionName = getBaseOptionName(optionName);
                              updateSwatchLabel($activeVariantSelects, baseOptionName, $input.val());
                          }
                      } else {
                          const optionName = $checkedInput.attr('name');
                          const baseOptionName = getBaseOptionName(optionName);
                          updateSwatchLabel($activeVariantSelects, baseOptionName, $checkedInput.val());
                      }
                  });
              }
              updateAllSelectedOptionSpans();
          }, 50);
      });

      // Initialize on page load
      initializeVariantSelection();

      // Click handler for variant selection
      $(document).on('click', '.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants .cstm_var_sel_wrapper:not(.disabled)', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        const $wrapper = $(this);
        const $variantSelects = $wrapper.closest('.cstm_rack_configure_prd_variants');
        const productIndex = $variantSelects.data('product-index');
        
        if (!$variantSelects.hasClass('is-active')) return;
        
        // Get the radio input
        const $input = $wrapper.find('input[type="radio"]');
        const optionValue = $input.val();
        const optionName = $input.attr('name');
        
        // Update the radio selection
        $input.prop('checked', true);
        
        // Extract option name without index suffix
        const baseOptionName = getBaseOptionName(optionName);
        
        // Update the swatch label - find dynamically
        updateSwatchLabel($variantSelects, baseOptionName, optionValue);
        
        updateTitleSpan();
      });

      // Initialize variant selection
      function initializeVariantSelection() {
          $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').each(function() {
              const $variantSelects = $(this);
              const productIndex = $variantSelects.data('product-index');
              let needsDefaults = false;
              
              // Check each fieldset for selected options
              $variantSelects.find('fieldset').each(function() {
                  const $fieldset = $(this);
                  const $checkedInput = $fieldset.find('input[type="radio"]:checked');
                  
                  if (!$checkedInput.length) {
                      needsDefaults = true;
                      // Select the first enabled option
                      const $firstEnabledWrapper = $fieldset.find('.cstm_var_sel_wrapper:not(.disabled)').first();
                      
                      if ($firstEnabledWrapper.length) {
                          const $input = $firstEnabledWrapper.find('input[type="radio"]');
                          $input.prop('checked', true);
                          
                          // Extract option name without index suffix
                          const optionName = $input.attr('name');
                          const baseOptionName = getBaseOptionName(optionName);
                          
                          // Update the swatch label
                          updateSwatchLabel($variantSelects, baseOptionName, $input.val());
                      }
                  } else {
                      // Update the swatch label for already selected options
                      const optionName = $checkedInput.attr('name');
                      const baseOptionName = getBaseOptionName(optionName);
                      updateSwatchLabel($variantSelects, baseOptionName, $checkedInput.val());
                  }
              });
              
              // Always update variant data (but NOT product info display)
              updateVariantData($variantSelects, productIndex, false);
          });

          updateAllSelectedOptionSpans();

      }

      // Update swatch label dynamically
      function updateSwatchLabel($variantSelects, optionName, optionValue) {
        const $fieldset = $variantSelects.find(`fieldset input[name*="${optionName}"]`).closest('fieldset');
        if ($fieldset.length) {
          const $legend = $fieldset.find('legend');
          const $span = $legend.find('[data-selected-swatch-value]');
          
          // Get the base legend text (before the colon)
          let baseText = $legend.text().split(':')[0].trim();
          
          // If we have duplicate text (like "Body Color Body Color"), clean it up
          const words = baseText.split(' ');
          if (words.length > 2 && words[0] === words[2]) {
            // We have duplicate text like "Body Color Body Color"
            baseText = words.slice(0, 2).join(' ');
          }
          
          // Update the legend with clean text and the selected value
          $legend.html(`${baseText}: <span data-selected-swatch-value="">${optionValue}</span>`);
        }
      }

      // Main function to update variant data
      function updateVariantData($variantSelects, productIndex, skipProductInfo = true) {
        // Get selected options
        const selectedOptions = getSelectedOptions($variantSelects);
        
        // Find matching variant
        const variant = findMatchingVariant($variantSelects, selectedOptions);
        
        if (variant && variant.id) {
          // Update active link with variant ID
          updateActiveLink(productIndex, variant.id);
        }
      }

      // Function to update product info section with variant data
      function updateProductInfo(productIndex, variant, selectedOptions, $variantSelects) {
          const $activeDiv = $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div.active');
          
          if ($activeDiv.length) {
              // Add configured-active class
              $activeDiv.addClass('configured-active');
              
              // Remove cstm_hide class from product info section
              const $productInfo = $activeDiv.find('.cstm_rack_configure_prd_info');
              $productInfo.removeClass('cstm_hide');
              
              // Get product name dynamically
              const productName = getProductName(variant, $variantSelects);
              
              // Update product name
              $productInfo.find('h5').text(productName);
              
              // Update product image if available
              updateProductImage($productInfo, variant);
              
              // Build options text dynamically with separate spans and swatches
              const optionsHTML = buildVariantTitleText(variant, selectedOptions, $variantSelects);
              
              // Update options HTML
              const $pElement = $productInfo.find('p');
              $pElement.html(optionsHTML);
              
              // Store all variant data dynamically
              storeVariantData($activeDiv, variant, selectedOptions, productName);
              
              // Hide the arrow image and "Configuring your S 76" span
              $activeDiv.find('> img').css('display', 'none');
              $activeDiv.find('> span').addClass('cstm_hide');
          }
      }

      // Get product name dynamically
      function getProductName(variant, $variantSelects) {
        if (variant.name) {
          const variantName = variant.name;
          const separatorIndex = variantName.lastIndexOf(' - ');
          if (separatorIndex !== -1) {
            return variantName.substring(0, separatorIndex);
          }
          return variantName;
        }
        
        const $h5 = $variantSelects.find('h5');
        if ($h5.length) {
          return $h5.text();
        }
        
        const productHandle = $variantSelects.data('product-handle');
        if (productHandle) {
          return productHandle
            .replace(/-/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase());
        }
        
        return 'Product Name';
      }

      // Update product image dynamically
      function updateProductImage($productInfo, variant) {
        const $img = $productInfo.find('img[alt="Product Image"]');
        
        if (variant.featured_image && variant.featured_image.src) {
          let imageSrc = variant.featured_image.src;
          
          if (!imageSrc.startsWith('http')) {
            if (imageSrc.startsWith('//')) {
              imageSrc = 'https:' + imageSrc;
            } else if (imageSrc.startsWith('/')) {
              imageSrc = 'https:' + imageSrc;
            }
          }
          
          $img.attr('src', imageSrc);
        } else {
          $img.attr('src', '');
        }
      }

      // Build variant title text dynamically with separate spans for each option
      function buildVariantTitleText(variant, selectedOptions, $variantSelects) {
        if (!variant || !variant.title) {
            return '<div class="option-line"><span class="option-label">Body Color:</span> <span class="option-value"></span></div>' +
                  '<div class="option-line"><span class="option-label">Catch Color:</span> <span class="option-value"></span></div>';
        }
        
        // Get option display names
        const displayNames = getOptionDisplayNames($variantSelects);
        
        let html = '';
        
        // Build HTML based on actual variant options (option1, option2, option3)
        if (variant.option1) {
            const displayName = displayNames.option1 || 'Body Color';
            html += buildOptionLineHTML(displayName, variant.option1, $variantSelects, 0);
        }
        
        if (variant.option2) {
            const displayName = displayNames.option2 || 'Catch Color';
            html += buildOptionLineHTML(displayName, variant.option2, $variantSelects, 1);
        }
        
        if (variant.option3) {
            const displayName = displayNames.option3 || 'Option 3';
            html += buildOptionLineHTML(displayName, variant.option3, $variantSelects, 2);
        }
        
        return html;
    }

    // Helper function to build option line HTML
    function buildOptionLineHTML(displayName, optionValue, $variantSelects, fieldsetIndex) {
        let html = `<div class="option-line">`;
        html += `<span class="option-label">${displayName}:</span> `;
        html += `<span class="option-value">`;
        
        // Try to get the swatch image for this value
        const $fieldset = $variantSelects.find('fieldset').eq(fieldsetIndex);
        if ($fieldset.length) {
            const $wrapper = $fieldset.find(`input[value="${optionValue}"]`).closest('.cstm_var_sel_wrapper');
            
            if ($wrapper.length) {
                const $label = $wrapper.find('label.cstm_swatch_color');
                if ($label.length) {
                    const style = $label.attr('style') || '';
                    const match = style.match(/background-image:\s*url\((['"]?)(.*?)\1\)/);
                    if (match && match[2]) {
                        html += `<span class="option-swatch" style="background-image: url(${match[2]});"></span>`;
                    }
                }
            }
        }
        
        html += `<span class="option-text">${optionValue}</span>`;
        html += `</span>`;
        html += `</div>`;
        
        return html;
    }

      // Store variant data dynamically
      function storeVariantData($element, variant, selectedOptions, productName) {
        $element.attr('data-variant-id', variant.id || '');
        $element.attr('data-product-name', productName || '');
        $element.attr('data-variant-image', (variant.featured_image && variant.featured_image.src) || '');
        $element.attr('data-sku', variant.sku || '');
        $element.attr('data-price', variant.price || '');
        $element.attr('data-options', JSON.stringify(selectedOptions));
        $element.attr('data-variant-title', variant.title || '');
        $element.attr('data-variant-data', JSON.stringify(variant));
      }

      // Get selected options dynamically
      function getSelectedOptions($variantSelects) {
        const options = {};
        
        // Get fieldset indexes to match option1, option2, option3 format
        $variantSelects.find('fieldset').each(function(index) {
          const $checkedInput = $(this).find('input[type="radio"]:checked');
          if ($checkedInput.length) {
            const optionValue = $checkedInput.val();
            
            // Store in Shopify format (option1, option2, option3)
            options[`option${index + 1}`] = optionValue;
            
            // Also store the display name for backward compatibility
            const optionName = $checkedInput.attr('name');
            const baseOptionName = getBaseOptionName(optionName);
            options[baseOptionName] = optionValue;
          }
        });
        
        return options;
      }

      // Helper function to extract base option name
      function getBaseOptionName(optionName) {
        return optionName.replace(/-\d+$/, '');
      }

      // Find matching variant dynamically
      function findMatchingVariant($variantSelects, selectedOptions) {
          const $script = $variantSelects.find('script[type="application/json"]');
          if (!$script.length) return null;
          
          try {
              const variants = JSON.parse($script.html());
              
              // Handle both array and object structures
              if (Array.isArray(variants)) {
                  for (let i = 0; i < variants.length; i++) {
                      const variant = variants[i];
                      
                      // Skip entries without id (like empty strings or null)
                      if (!variant || !variant.id) continue;
                      
                      if (isVariantMatch(variant, selectedOptions)) {
                          return variant;
                      }
                  }
              }
              
          } catch (e) {
              console.error('Error parsing variant JSON:', e);
          }
          
          return null;
      }

      // Check if variant matches selected options
      function isVariantMatch(variant, selectedOptions) {
        if (!variant || !variant.id) return false;
        
        // Check option1, option2, option3 format (Shopify standard)
        const matchOption1 = (!selectedOptions.option1 || !variant.option1) ? true : 
                            selectedOptions.option1.toLowerCase() === variant.option1.toLowerCase();
        
        const matchOption2 = (!selectedOptions.option2 || !variant.option2) ? true : 
                            selectedOptions.option2.toLowerCase() === variant.option2.toLowerCase();
        
        const matchOption3 = (!selectedOptions.option3 || !variant.option3) ? true : 
                            selectedOptions.option3.toLowerCase() === variant.option3.toLowerCase();
        
        // Also check variant.options array for backward compatibility
        const variantOptionsMatch = (variant.options && Array.isArray(variant.options)) ? 
          checkVariantOptionsArray(variant.options, selectedOptions) : true;
        
        return matchOption1 && matchOption2 && matchOption3 && variantOptionsMatch;
      }

      // Helper function for variant options array check
      function checkVariantOptionsArray(variantOptions, selectedOptions) {
        // Convert selected options to array of values
        const selectedValues = Object.values(selectedOptions);
        
        // Check if all selected values exist in variant options
        for (const selectedValue of selectedValues) {
          let found = false;
          for (const variantOption of variantOptions) {
            if (variantOption && variantOption.toLowerCase() === selectedValue.toLowerCase()) {
              found = true;
              break;
            }
          }
          if (!found) return false;
        }
        
        return true;
      }

      // Helper function to get option display names from fieldset legends
      function getOptionDisplayNames($variantSelects) {
        const displayNames = {};
        
        $variantSelects.find('fieldset').each(function(index) {
          const $legend = $(this).find('legend');
          let legendText = $legend.text().split(':')[0].trim();
          
          // Clean up the legend text
          if (legendText.toLowerCase().includes('body color')) {
            legendText = 'Body Color';
          } else if (legendText.toLowerCase().includes('catch color')) {
            legendText = 'Catch Color';
          }
          
          displayNames[`option${index + 1}`] = legendText;
        });
        
        return displayNames;
      }

      // Update active link with variant ID
      function updateActiveLink(productIndex, variantId) {
        const $activeAnchor = $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div.active');
        
        if ($activeAnchor.length) {
          $activeAnchor.attr('data-variant-id', variantId);
        }
      }

      // Apply to all functionality
      $(document).on('change', '#apply-to-all', function() {
        if ($(this).is(':checked')) {
          console.log('Apply to all checked - selections will be applied to all when styling is applied');
        } else {
          console.log('Apply to all unchecked');
        }
      });

      // SIMPLIFIED: Apply selections to all product info divs
      function applySelectionsToAll() {
        const $activeVariantSelects = $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants.is-active');
        const selectedOptions = getSelectedOptions($activeVariantSelects);
        const activeVariant = findMatchingVariant($activeVariantSelects, selectedOptions);
        
        if (!activeVariant) return;
        
        // Apply to all product info divs
        applyVariantInfoToAllDivs(activeVariant, selectedOptions);
        
        // Update total price and button state
        updateTotalPriceAndButton();
      }

      // SIMPLIFIED: Apply variant info to all divs
      function applyVariantInfoToAllDivs(variant, selectedOptions) {
          // Get product name from the active variant selector
          const $activeVariantSelects = $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants.is-active');
          const productName = getProductName(variant, $activeVariantSelects);
          
          // Update ALL divs
          $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div').each(function() {
              const $div = $(this);
              
              // Add configured-active class
              $div.addClass('configured-active');
              
              // Remove cstm_hide class from product info section
              const $productInfo = $div.find('.cstm_rack_configure_prd_info');
              $productInfo.removeClass('cstm_hide');
              
              // Update product name
              $productInfo.find('h5').text(productName);
              
              // Update product image
              updateProductImage($productInfo, variant);
              
              // Build variant title text with swatches
              const optionsHTML = buildVariantTitleText(variant, selectedOptions, $activeVariantSelects);
              
              // Update options HTML
              $productInfo.find('p').html(optionsHTML);
              
              // Store variant data
              storeVariantData($div, variant, selectedOptions, productName);
              
              // Update the variant ID on the div
              $div.attr('data-variant-id', variant.id || '');
              
              // Hide the arrow image and "Configuring your S 76" span for ALL configured items
              $div.find('> img').css('display', 'none');
              $div.find('> span').addClass('cstm_hide');
          });
      }

      // Handle Apply Styling button - SIMPLIFIED
      $(document).on('click', '.apply-styling-btn', function(e) {
          e.preventDefault();
          
          const $activeVariantSelects = $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants.is-active');
          const selectedOptions = getSelectedOptions($activeVariantSelects);
          const activeVariant = findMatchingVariant($activeVariantSelects, selectedOptions);
          
          if (!activeVariant) {
              console.log('No variant found for selected options');
              console.log(activeVariant);
              return;
          }
          
          // Check if "Apply to all" checkbox is checked
          const applyToAllChecked = $('#apply-to-all').is(':checked');
          
          if (applyToAllChecked) {
              // Apply selections to all divs
              applySelectionsToAll();
          } else {
              // Only update the active div
              const $activeDiv = $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div.active');
              
              if ($activeDiv.length && $activeVariantSelects.length) {
                  // Update product info
                  $activeDiv.addClass('configured-active');
                  
                  // Remove cstm_hide class from product info section
                  const $productInfo = $activeDiv.find('.cstm_rack_configure_prd_info');
                  $productInfo.removeClass('cstm_hide');
                  
                  // Get product name dynamically
                  const productName = getProductName(activeVariant, $activeVariantSelects);
                  
                  // Update product name
                  $productInfo.find('h5').text(productName);
                  
                  // Update product image
                  updateProductImage($productInfo, activeVariant);
                  
                  // Build variant title text with swatches
                  const optionsHTML = buildVariantTitleText(activeVariant, selectedOptions, $activeVariantSelects);
                  
                  // Update options HTML
                  $productInfo.find('p').html(optionsHTML);
                  
                  // Store variant data
                  storeVariantData($activeDiv, activeVariant, selectedOptions, productName);
                  
                  // Hide the arrow image and "Configuring your S 76" span
                  $activeDiv.find('> img').css('display', 'none');
                  $activeDiv.find('> span').addClass('cstm_hide');
              }
          }
          
          // Hide configuration panel and show the "Select a slot" message
          $('.cstm_rack_configure_wrapper_details').removeClass('active');
          $('.cstm_rack_configure_wrapper_new_inner_main_flexitem2_span').removeClass('cstm_hide');
          
          // Collect all variant selections for submission
          const allSelections = collectAllVariantSelections();
          
          console.log('All variant selections:', allSelections);
          
          // Update total price and button state
          updateTotalPriceAndButton();
      });

      // Collect all variant selections
      function collectAllVariantSelections() {
        const allSelections = [];
        
        $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div').each(function(index) {
          const variantId = $(this).attr('data-variant-id');
          if (variantId) {
            const variantData = {
              linkIndex: index,
              variantId: variantId,
              productName: $(this).attr('data-product-name') || '',
              sku: $(this).attr('data-sku') || '',
              price: $(this).attr('data-price') || '',
              variantTitle: $(this).attr('data-variant-title') || '',
              isConfigured: $(this).hasClass('configured-active'),
              options: JSON.parse($(this).attr('data-options') || '{}'),
              variantData: JSON.parse($(this).attr('data-variant-data') || '{}')
            };
            allSelections.push(variantData);
          }
        });
        
        return allSelections;
      }

      // Handle edit selection button - UPDATED: Activate first variant selector
      $(document).on('click', '.cstm_rack_configure_prd_info_item3 span:first-child', function(e) {
          e.preventDefault();
          e.stopPropagation();

          // UNCHECK APPLY-TO-ALL CHECKBOX WHEN USER CLICKS ANY DIV
          const $applyToAllCheckbox = $('#apply-to-all');
          if ($applyToAllCheckbox.is(':checked')) {
              $applyToAllCheckbox.prop('checked', false);
          }
          
          const $productInfo = $(this).closest('.cstm_rack_configure_prd_info');
          const $parentDiv = $productInfo.closest('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div');
          
          // Get stored configuration data
          const variantDataJSON = $parentDiv.attr('data-variant-data');
          const optionsJSON = $parentDiv.attr('data-options');
          
          let variantData = {};
          let storedOptions = {};
          
          try {
              if (variantDataJSON) variantData = JSON.parse(variantDataJSON);
              if (optionsJSON) storedOptions = JSON.parse(optionsJSON);
          } catch (e) {
              console.error('Error parsing stored configuration data:', e);
          }
          
          // Activate this div and show its configuration
          $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div').removeClass('active');
          $parentDiv.addClass('active configured-active');
          
          // Update all images based on product data (not just show all)
          $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div > img').each(function() {
              const $thisImg = $(this);
              const $imgParentDiv = $thisImg.parent('div');
              
              // Check if parent div has product data
              const hasProductData = $imgParentDiv.hasClass('configured-active') || $imgParentDiv.attr('data-variant-id');
              
              if (hasProductData) {
                  // Has product data, hide the image
                  $thisImg.css('display', 'none');
              } else {
                  // Doesn't have product data, show the image
                  $thisImg.css('display', 'block');
              }
          });
          
          // Update text - keep cstm_hide class on span since product info is visible
          $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div > span').text('Add an s 76 to configure');
          $parentDiv.find('> span').text('Configuring your S 76').addClass('cstm_hide');
          
          // Show configuration panel
          $('.cstm_rack_configure_wrapper_new_inner_main_flexitem2_span').addClass('cstm_hide');
          $('.cstm_rack_configure_wrapper_details').addClass('active');
          
          // FIRST, reset all legends to avoid duplicate text
          resetAllSwatchLegends();
          
          // Determine which product type to activate based on stored data
          activateCorrectProductType($parentDiv, variantData);
          
          // After a short delay to ensure DOM is ready, preselect the stored options
          setTimeout(function() {
              preselectStoredOptions(storedOptions, variantData);
              // ADD THIS LINE - Update all legend spans after loading stored options
              updateAllSelectedOptionSpans();
          }, 50);
          
          // Update total price and button state
          updateTotalPriceAndButton();
      });

      // Handle remove button
      $(document).on('click', '.cstm_rack_configure_prd_info_item3 span:last-child', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const $productInfo = $(this).closest('.cstm_rack_configure_prd_info');
        const $parentDiv = $productInfo.closest('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div');
        
        // Reset this div
        resetProductConfiguration($parentDiv, $productInfo);
      });

      // NEW: Function to reset all swatch legends to avoid duplicate text
      function resetAllSwatchLegends() {
        $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants fieldset legend').each(function() {
          const $legend = $(this);
          const originalText = $legend.text().split(':')[0].trim();
          
          // Reset to original format
          $legend.html(originalText + ' <span data-selected-swatch-value=""></span>');
        });
      }

      // NEW: Function to activate the correct product type (style) based on stored data
      function activateCorrectProductType($parentDiv, variantData) {
        if (!variantData || !variantData.id) {
          // No variant data, activate first variant selector
          $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').removeClass('is-active');
          $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').first().addClass('is-active');
          return;
        }
        
        // Get variant ID from stored data
        const variantId = variantData.id;
        
        // Find which product variant selector contains this variant ID
        let foundProductHandle = null;
        
        $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').each(function() {
          const $variantSelects = $(this);
          const $script = $variantSelects.find('script[type="application/json"]');
          
          if ($script.length) {
            try {
              const variants = JSON.parse($script.html());
              
              // Check if any variant in this set matches our stored variant ID
              if (Array.isArray(variants)) {
                for (let i = 0; i < variants.length; i++) {
                  const variant = variants[i];
                  if (variant && variant.id === variantId) {
                    foundProductHandle = $variantSelects.data('product-handle');
                    break;
                  }
                }
              }
            } catch (e) {
              console.error('Error parsing variant JSON:', e);
            }
          }
        });
        
        if (foundProductHandle) {
          // Activate the correct product type
          $('.cstm_rack_configure_wrapper_details .rack-option').removeClass('is-active');
          $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').removeClass('is-active');
          
          $(`.rack-option[data-product-handle="${foundProductHandle}"]`).addClass('is-active');
          $(`.cstm_rack_configure_prd_variants[data-product-handle="${foundProductHandle}"]`).addClass('is-active');
        } else {
          // Fallback: activate first variant selector
          $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').removeClass('is-active');
          $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').first().addClass('is-active');
        }
      }

      // NEW: Function to preselect stored options in the configuration panel
      function preselectStoredOptions(storedOptions, variantData) {
        // Only proceed if we have stored options
        if (!storedOptions || Object.keys(storedOptions).length === 0) {
          return;
        }
        
        // Get the active variant selector
        const $activeVariantSelects = $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants.is-active');
        
        if (!$activeVariantSelects.length) {
          return;
        }
        
        // For each stored option, find and select the corresponding radio button
        Object.keys(storedOptions).forEach(function(optionName) {
          const optionValue = storedOptions[optionName];
          
          // Try to find the radio button by value
          // We need to find the fieldset that contains the option name in its legend
          const $fieldset = $activeVariantSelects.find('fieldset').filter(function() {
            const legendText = $(this).find('legend').text().split(':')[0].trim();
            return legendText.toLowerCase().includes(optionName.toLowerCase());
          });
          
          if ($fieldset.length) {
            // Get the actual input name (with suffix)
            const $sampleInput = $fieldset.find('input[type="radio"]').first();
            const actualOptionName = $sampleInput.attr('name');
            
            // Find and select the radio button with matching value
            const $targetInput = $activeVariantSelects.find(`input[name="${actualOptionName}"][value="${optionValue}"]`);
            
            if ($targetInput.length && !$targetInput.closest('.cstm_var_sel_wrapper').hasClass('disabled')) {
              // Select the radio button
              $targetInput.prop('checked', true);
              
              // Update the swatch label WITHOUT calling updateSwatchLabel (to avoid duplicate text)
              const $legend = $fieldset.find('legend');
              const legendText = $legend.text().split(':')[0].trim();
              $legend.html(`${legendText}: <span data-selected-swatch-value="">${optionValue}</span>`);
            }
          }
        });
        
        // After preselecting options, update variant data (but not product info display)
        const productIndex = $activeVariantSelects.data('product-index');
        
        // Call a modified version of updateVariantData that doesn't trigger updateSwatchLabel
        updateVariantDataForEdit($activeVariantSelects, productIndex);
      }

      // NEW: Modified version of updateVariantData that doesn't trigger updateSwatchLabel
      function updateVariantDataForEdit($variantSelects, productIndex) {
        // Get selected options
        const selectedOptions = getSelectedOptions($variantSelects);
        
        // Find matching variant
        const variant = findMatchingVariant($variantSelects, selectedOptions);
        
        if (variant && variant.id) {
          // Update active link with variant ID
          updateActiveLink(productIndex, variant.id);
        }
      }

      // Function to reset product configuration
      function resetProductConfiguration($div, $productInfo) {
          $div.removeClass('active configured-active');
          
          // Remove all data attributes
          const dataAttributes = [
              'data-variant-id',
              'data-product-name',
              'data-variant-image',
              'data-sku',
              'data-price',
              'data-options',
              'data-variant-title',
              'data-variant-data'
          ];
          
          dataAttributes.forEach(attr => {
              $div.removeAttr(attr);
          });
          
          // Show the arrow image and remove cstm_hide from span
          $div.find('> img').css('display', 'block');
          $div.find('> span').removeClass('cstm_hide');
          
          // Reset text
          $div.find('> span').text('Add an s 76 to configure');
          
          // Hide product info
          $productInfo.addClass('cstm_hide');
          
          // Reset product info content - update to new structure
          $productInfo.find('h5').text('PRODUCT NAME');
          $productInfo.find('img[alt="Product Image"]').attr('src', '');
          $productInfo.find('p').html(
              '<div class="option-line"><span class="option-label">Body Color:</span> <span class="option-value"></span></div>' +
              '<div class="option-line"><span class="option-label">Catch Color:</span> <span class="option-value"></span></div>'
          );
          
          // Update total price and button state
          updateTotalPriceAndButton();
      }

      // NEW: Function to update the total price and button state (WITH BASE PRICE)
      function updateTotalPriceAndButton() {
          const $priceSpan = $('.cstm_rack_configure_wrapper_new_inner_atc p span');
          const $atcButton = $('.cstm_rack_configure_wrapper_new_inner_atc a');
          const $configurationPanel = $('.cstm_rack_configure_wrapper_details');
          
          // Count how many divs have configured-active class
          const configuredCount = $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div.configured-active').length;
          
          // Calculate total price from configured items
          let totalPrice = 0;
          $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div.configured-active').each(function() {
              const price = $(this).attr('data-price');
              if (price) {
                  totalPrice += parseInt(price) || 0;
              }
          });
          
          // Get base price
          const $basePriceElement = $('.cstm_rack_configure_main_prd_variants span');
          let basePrice = 0;
          
          if ($basePriceElement.length) {
              const basePriceText = $basePriceElement.text().trim();
              
              // IMPROVED: Better regex to extract the numeric value including decimal
              const priceMatch = basePriceText.match(/(\d{1,3}(?:,\d{3})*(?:\.\d{2})?)/);
              
              if (priceMatch && priceMatch[1]) {
                  let numericValue = priceMatch[1];
                  numericValue = numericValue.replace(/,/g, '');
                  const parsedValue = parseFloat(numericValue);
                  
                  if (!isNaN(parsedValue)) {
                      // Get sample configured item to determine price format
                      const sampleDiv = $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div.configured-active').first();
                      
                      if (sampleDiv.length) {
                          const samplePrice = sampleDiv.attr('data-price');
                          if (samplePrice) {
                              const samplePriceNum = parseInt(samplePrice);
                              if (samplePriceNum > 1000) {
                                  basePrice = Math.round(parsedValue * 100);
                              } else {
                                  basePrice = parsedValue;
                              }
                          }
                      } else {
                          // Fallback: check if base price has decimal places
                          if (basePriceText.includes('.') && !basePriceText.includes(',')) {
                              basePrice = Math.round(parsedValue * 100);
                          } else {
                              basePrice = parsedValue;
                          }
                      }
                  }
              }
          }
          
          // Add base price to total (added once regardless of how many items)
          if (configuredCount > 0 && basePrice > 0) {
              totalPrice += basePrice;
          }
          
          // Format price for display
          let formattedPrice = '';
          if (totalPrice > 0) {
              // Determine if price needs to be divided by 100 (if in cents)
              const sampleDiv = $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div.configured-active').first();
              if (sampleDiv.length) {
                  const samplePrice = sampleDiv.attr('data-price');
                  if (samplePrice) {
                      const samplePriceNum = parseInt(samplePrice);
                      if (samplePriceNum > 1000) {
                          formattedPrice = (totalPrice / 100).toFixed(2);
                      } else {
                          formattedPrice = totalPrice.toFixed(2);
                      }
                  }
              } else {
                  // Fallback formatting
                  if ($basePriceElement.length) {
                      const basePriceText = $basePriceElement.text().trim();
                      if (basePriceText.includes('.') && !basePriceText.includes(',')) {
                          formattedPrice = (totalPrice / 100).toFixed(2);
                      } else {
                          formattedPrice = totalPrice.toFixed(2);
                      }
                  } else {
                      formattedPrice = (totalPrice / 100).toFixed(2);
                  }
              }
              
              // Add currency formatting
              if ($basePriceElement.length) {
                  const basePriceText = $basePriceElement.text().trim();
                  const currencyMatch = basePriceText.match(/^[^\d]+/);
                  let currencyPrefix = '';
                  if (currencyMatch) {
                      currencyPrefix = currencyMatch[0].trim() + ' ';
                  }
                  
                  // Add thousand separators if base price has them
                  if (basePriceText.includes(',')) {
                      const parts = formattedPrice.split('.');
                      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                      formattedPrice = currencyPrefix + parts.join('.');
                  } else {
                      formattedPrice = currencyPrefix + formattedPrice;
                  }
              } else {
                  formattedPrice = '$' + formattedPrice;
              }
          }
          
          // Update price display
          $priceSpan.text(formattedPrice);
          
          // Update button state and text
          const isConfiguring = $configurationPanel.hasClass('active');
          
          if (configuredCount > 0 && !isConfiguring) {
              $atcButton
                  .removeClass('disabled')
                  .addClass('active')
                  .text('Add to Cart')
                  .attr('href', '#add-to-cart');
          } else {
              $atcButton
                  .addClass('disabled')
                  .removeClass('active')
                  .text('Finish Customizing')
                  .attr('href', '#');
          }
      }

      // NEW: Function to get all variant IDs from configured divs
      function getAllConfiguredVariantIds() {
        const variantIds = [];
        
        $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div').each(function() {
          const variantId = $(this).attr('data-variant-id');
          if (variantId) {
            variantIds.push(variantId);
          }
        });
        
        return variantIds;
      }

      // NEW: Function to add class to product form submit button
      function addSuccessClassToProductForm() {
        // Find the product form submit button and add the class
        const $productFormSubmit = $('.template-product .product-form__submit');
        
        if ($productFormSubmit.length) {
          $productFormSubmit.addClass('cstm_rack_config_prd-added');
          $productFormSubmit.click();
          setTimeout(function() {
            $productFormSubmit.removeClass('cstm_rack_config_prd-added');
          }, 500);
        }
      }

      // UPDATED: Handle click on Add to Cart button with AJAX functionality
      $(document).on('click', '.cstm_rack_configure_wrapper_new_inner_atc a', function(e) {
        const $button = $(this);
        
        // If button is disabled or says "Finish Customizing", prevent default
        if ($button.hasClass('disabled') || $button.text() === 'Finish Customizing') {
          e.preventDefault();
          
          // If there are no configured items but user clicks "Finish Customizing"
          const configuredCount = $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div.configured-active').length;
          if (configuredCount === 0) {
            // Optional: Show message or open first slot for configuration
            console.log('Please configure at least one S 76 before proceeding.');
            let errorMsg = "Please configure at least one S 76 before proceeding.";
            showErrorMsgPopup(errorMsg);
          }
          
          return;
        }
        
        // Button is "Add to Cart" and active - prevent default and add to cart via AJAX
        e.preventDefault();

        // Check the selected rack variant stock availability dynamically from JSON
        let isMainVariantAvailable = true;
        try {
            // Find the visible variant selectors where user choices are actually recorded
            const $visibleSelects = $('.product__info-container > variant-selects').first();
            const rackOptions = [];

            if ($visibleSelects.length) {
                $visibleSelects.find('fieldset').each(function() {
                    let val = $(this).find('input[type="radio"]:checked').val();
                    // Fallback to checking theme's legend span if input state isn't tracked immediately
                    if (!val) {
                        val = $(this).find('legend span').text();
                    }
                    if (val) {
                        rackOptions.push(val.replace(/\u00A0/g, ' ').trim().toLowerCase());
                    }
                });
            }

            // Target the specific hidden payload container holding the variations matrix array
            const $mainJsonScript = $('.cstm_rack_configure_main_prd_variants script[type="application/json"]');
            if ($mainJsonScript.length && rackOptions.length >= 2) {
                let mainVariants = JSON.parse($mainJsonScript.html());
                if (Array.isArray(mainVariants) && mainVariants[0] === "") {
                    mainVariants = mainVariants.slice(1);
                }

                // Match options against option1, option2, option3 properties case-insensitively
                const matchedMainVariant = mainVariants.find(v => {
                    if (!v) return false;
                    const match1 = !rackOptions[0] || (v.option1 && v.option1.toLowerCase().trim() === rackOptions[0]);
                    const match2 = !rackOptions[1] || (v.option2 && v.option2.toLowerCase().trim() === rackOptions[1]);
                    const match3 = !rackOptions[2] || (v.option3 && v.option3.toLowerCase().trim() === rackOptions[2]);
                    return match1 && match2 && match3;
                });

                // Set availability tracking flag directly from target payload entry
                if (matchedMainVariant && matchedMainVariant.available === false) {
                    isMainVariantAvailable = false;
                }
            }
        } catch (e) {
            console.error('Error verifying main variant choice availability payload:', e);
            // Fallback safety layer to button selector if parsing breaks down
            if ($('.template-product .product-form__submit').is(':disabled')) {
                isMainVariantAvailable = false;
            }
        }
        
        // Show error message popup if the matched combination is out of stock
        if (!isMainVariantAvailable) {
            console.log('The selected variant of Systainer³ Rack M 337 is out of stock. Please select a different one.');
            let errorMsg = "The selected variant of Systainer³ Rack M 337 is out of stock. Please select a different one.";
            showErrorMsgPopup(errorMsg);

            return;
        }

        // If it passes the check above, ensure the product form submit button is enabled
        $('.template-product .product-form__submit').prop('disabled', false).removeAttr('disabled');
        
        // Get all variant IDs
        const variantIds = getAllConfiguredVariantIds();
        
        if (variantIds.length === 0) {
          console.log('No variant IDs found to add to cart');
          alert('Please configure at least one S 76 before adding to cart.');
          return;
        }
        
        console.log('Adding to cart variant IDs:', variantIds);
        
        // Show loading state
        const originalText = $button.text();
        $button.text('Adding to Cart...').addClass('loading');
        
        // Prepare cart items data for Shopify
        const cartItems = variantIds.map(variantId => ({
          id: variantId,
          quantity: 1
        }));
        
        // Log what we're sending
        console.log('Cart items to send:', cartItems);
        
        // Make AJAX request to add all items to cart
        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify({
            items: cartItems
          }),
          success: function(response) {
            console.log('Successfully added to cart:', response);
            
            // Reset button state
            $button.text(originalText).removeClass('loading');
            
            // Add success class to product form submit button
            addSuccessClassToProductForm();
          },
          error: function(xhr, status, error) {
            console.error('Error adding to cart:', error, xhr.responseText);
            
            // Reset button state
            $button.text(originalText).removeClass('loading');
            
            // Parse the error response to get detailed message
            let errorMessage = 'Error adding items to cart. Please try again.';
            let variantIdWithError = null;
            
            try {
              if (xhr.responseText) {
                const errorData = JSON.parse(xhr.responseText);
                if (errorData.description) {
                  errorMessage = errorData.description;
                  
                  // Extract variant ID from error message if possible
                  // Shopify usually includes "variant" in the error description
                  if (errorData.description.includes('variant') || errorData.description.includes('#')) {
                    // Try to extract variant ID
                    const variantMatch = errorData.description.match(/variant (\d+)/);
                    if (variantMatch && variantMatch[1]) {
                      variantIdWithError = variantMatch[1];
                    }
                  }
                }
              }
            } catch (e) {
              console.log('Could not parse error response:', e);
            }
            
            // Create and show popup with error message
            showInventoryErrorPopup(errorMessage, variantIdWithError);
          }
        });
      });

      // NEW: Function to show inventory error popup
      function showInventoryErrorPopup(errorMessage, variantId = null) {
        // Parse the error message to extract inventory quantity
        let displayMessage = errorMessage;
        let inventoryQty = null;
        
        // Extract number from error message (e.g., "only has 2 in stock")
        const qtyMatch = errorMessage.match(/only has (\d+) in stock/);
        if (qtyMatch && qtyMatch[1]) {
          inventoryQty = qtyMatch[1];
          displayMessage = `The variant you tried to select only has ${inventoryQty} in stock. Please select a different variant.`;
        } else {
          // If no quantity found, use the original error message but formatted
          displayMessage = errorMessage.replace(/only has # in stock/, 'only has 0 in stock');
        }
        
        // Check if popup already exists
        let $popup = $('.cstm_inventory_error_popup');
        
        // Remove existing popup if any
        if ($popup.length) {
          $popup.remove();
        }
        
        // Create popup with updated CSS styles
        $popup = $('<div class="cstm_inventory_error_popup" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;">' +
                  '<div class="popup_content" style="background: #fff; padding: 60px; border-radius: 8px; max-width: 90%; width: 90%; text-align: center; box-shadow: 0 4px 20px rgba(0,0,0,0.15); position: relative;">' +
                  '<div class="popup_close" style="position: absolute; top: 20px; right: 20px; width: 28px; height: 28px; cursor: pointer; font-size: 28px; color: #888; line-height: 1; display: flex; align-items: center; justify-content: center;">&times;</div>' +
                  '<div class="popup_message" style="margin-top: 40px; color: #004F9F; text-align: center; font-size: 20px; font-style: normal; font-weight: 600; line-height: 120%; letter-spacing: -0.8px;"></div>' +
                  '</div>' +
                  '</div>');
        
        $('body').append($popup);
        
        // Set the message
        $popup.find('.popup_message').text(displayMessage);
        
        // Add click handler for close icon
        $popup.find('.popup_close').on('click', function() {
          $popup.fadeOut(300, function() {
            $(this).remove();
          });
        });
        
        // Close popup when clicking outside
        $popup.on('click', function(e) {
          if ($(e.target).hasClass('cstm_inventory_error_popup')) {
            $popup.fadeOut(300, function() {
              $(this).remove();
            });
          }
        });
        
        // Show popup
        $popup.fadeIn(300);
      }

      // NEW: Function to show inventory error popup
      function showErrorMsgPopup(errorMsg) {
        // Parse the error message to extract inventory quantity
        let displayErrorMessage = errorMsg;
        
        // Check if popup already exists
        let $errorPopup = $('.cstm_inventory_error_popup');
        
        // Remove existing popup if any
        if ($errorPopup.length) {
          $errorPopup.remove();
        }
        
        // Create popup with updated CSS styles
        $errorPopup = $('<div class="cstm_inventory_error_popup" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;">' +
                  '<div class="popup_content" style="background: #fff; padding: 60px; border-radius: 8px; max-width: 90%; width: 90%; text-align: center; box-shadow: 0 4px 20px rgba(0,0,0,0.15); position: relative;">' +
                  '<div class="popup_close" style="position: absolute; top: 20px; right: 20px; width: 28px; height: 28px; cursor: pointer; font-size: 28px; color: #888; line-height: 1; display: flex; align-items: center; justify-content: center;">&times;</div>' +
                  '<div class="popup_message" style="margin-top: 40px; color: #004F9F; text-align: center; font-size: 20px; font-style: normal; font-weight: 600; line-height: 120%; letter-spacing: -0.8px;"></div>' +
                  '</div>' +
                  '</div>');
        
        $('body').append($errorPopup);
        
        // Set the message
        $errorPopup.find('.popup_message').text(displayErrorMessage);
        
        // Add click handler for close icon
        $errorPopup.find('.popup_close').on('click', function() {
          $errorPopup.fadeOut(300, function() {
            $(this).remove();
          });
        });
        
        // Close popup when clicking outside
        $errorPopup.on('click', function(e) {
          if ($(e.target).hasClass('cstm_inventory_error_popup')) {
            $errorPopup.fadeOut(300, function() {
              $(this).remove();
            });
          }
        });
        
        // Show popup
        $errorPopup.fadeIn(300);
      }

      // UPDATED: On page load, set up initial display based on existing data
      $(document).ready(function() {
        // Check each div and update display based on existing data
        $('.cstm_rack_configure_wrapper_new_inner_main_flexitem1 > div').each(function() {
          const $div = $(this);
          
          // Check if div has product data (has configured-active class OR data-variant-id)
          const hasProductData = $div.hasClass('configured-active') || $div.attr('data-variant-id');
          
          if (hasProductData) {
            // This div has product data, so hide the plus image and show product info
            const $img = $div.find('> img');
            const $span = $div.find('> span');
            const $productInfo = $div.find('.cstm_rack_configure_prd_info');
            
            // Force hide the image with inline style
            $img.css('display', 'none');
            $span.addClass('cstm_hide');
            $productInfo.removeClass('cstm_hide');
          } else {
            // This div doesn't have product data, show plus image
            const $img = $div.find('> img');
            const $span = $div.find('> span');
            
            // Force show the image with inline style
            $img.css('display', 'block');
            $span.removeClass('cstm_hide');
          }
        });
        
        // Ensure the first variant selector has is-active class on page load
        $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').removeClass('is-active');
        $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants').first().addClass('is-active');
        
        // NEW: Initialize price and button state on page load
        updateTotalPriceAndButton();

        updateTitleSpan();
      });

      $('.template-product .product-form__submit').click(function(event) {
        if(!$(this).hasClass('cstm_rack_config_prd-added')) {
            event.preventDefault();
            event.stopPropagation();
            
            var rackSelectedPrd = $('.cstm_rack_prd_container').attr('data-selected-variant');
            var $button = $(this);

            // Grab main quantity input value and calculate rack quantity (multiplier of 6)
            var mainQuantity = parseInt($('.product-form__quantity .quantity__input').val(), 10) || 1;
            var rackQuantity = mainQuantity * 6;
            
            // Proceed with adding to cart
            $button.addClass('loading').prop('disabled', true);
            
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    items: [{
                        id: rackSelectedPrd,
                        quantity: rackQuantity
                    }]
                },
                dataType: 'json',
                success: function(response) {
                    $button.removeClass('loading').addClass('cstm_rack_config_prd-added');
                    setTimeout(function() {
                        $button.prop('disabled', false);
                        $button.click();
                        // Remove the class after clicking
                        setTimeout(function() {
                            $button.removeClass('cstm_rack_config_prd-added');
                        }, 500);
                    }, 500);
                },
                error: function(xhr) {
                    $button.removeClass('loading').prop('disabled', false);
                    let errorMessage = 'Error adding product to cart.';
                    try {
                        if (xhr.responseText) {
                            const errorData = JSON.parse(xhr.responseText);
                            if (errorData.description) {
                                // Extract inventory quantity
                                const qtyMatch = errorData.description.match(/only has (\d+) in stock/);
                                if (qtyMatch && qtyMatch[1]) {
                                    errorMessage = `The variant you tried to select only has ${qtyMatch[1]} in stock. Please select a different variant.`;
                                } else {
                                    errorMessage = errorData.description;
                                }
                            }
                        }
                    } catch (e) {
                        console.log('Could not parse error response:', e);
                    }
                    showInventoryErrorPopup(errorMessage);
                }
            });
        }
    });


    // Helper function to get base product price
    function getBaseProductPrice() {
        const $baseProductVariantSelects = $('.cstm_rack_configure_prd_variants[data-product-handle="systainer3-s-76"]');
        if (!$baseProductVariantSelects.length) return 0;
        
        // Get the first variant from the JSON
        const $script = $baseProductVariantSelects.find('script[type="application/json"]');
        if (!$script.length) return 0;
        
        try {
            const variants = JSON.parse($script.html());
            if (Array.isArray(variants) && variants.length > 1 && variants[1].price) {
                return parseInt(variants[1].price) || 0;
            }
        } catch (e) {
            console.error('Error parsing base product JSON:', e);
        }
        
        return 0;
    }

    // Helper function to get active product price
    function getActiveProductPrice($activeVariantSelects) {
        if (!$activeVariantSelects.length) return 0;
        
        // Get the first variant from the JSON
        const $script = $activeVariantSelects.find('script[type="application/json"]');
        if (!$script.length) return 0;
        
        try {
            const variants = JSON.parse($script.html());
            if (Array.isArray(variants) && variants.length > 1 && variants[1].price) {
                return parseInt(variants[1].price) || 0;
            }
        } catch (e) {
            console.error('Error parsing active product JSON:', e);
        }
        
        return 0;
    }

    // Function to update the title span based on active product
    function updateTitleSpan() {
      const $activeVariantSelects = $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants.is-active');
      const $titleSpan = $('.configure-rack-options-title > span');
      
      if (!$activeVariantSelects.length) {
          return;
      }
      
      // Get the product name from the h5 inside the variant selects
      const $productNameH5 = $activeVariantSelects.find('h5');
      const productName = $productNameH5.length ? $productNameH5.text().trim() : '';
      
      // If it's the base product (Systainer³ S 76), remove the text
      if ($activeVariantSelects.data('product-handle') === 'systainer3-s-76') {
          $titleSpan.text('').attr('data-selected-swatch-value', '');
          return;
      }
      
      // For other products, extract the suffix and calculate price difference
      if (productName) {
          // Extract the suffix (everything after "Systainer³ S 76")
          const baseProductName = 'Systainer³ S 76';
          let suffix = productName.replace(baseProductName, '').trim();
          
          // If suffix starts with "with" or "With", capitalize properly
          if (suffix.toLowerCase().startsWith('with')) {
              suffix = suffix.charAt(0).toUpperCase() + suffix.slice(1);
          }
          
          // Calculate price difference
          const baseProductPrice = getBaseProductPrice();
          const activeProductPrice = getActiveProductPrice($activeVariantSelects);
          const priceDifference = activeProductPrice - baseProductPrice;
          
          // Format the suffix with price difference
          let formattedSuffix = suffix;
          
          if (priceDifference > 0) {
              // Format price with dynamic currency
              const formattedPrice = formatPriceWithCurrency(priceDifference);
              formattedSuffix = ` ${suffix} (+ ${formattedPrice})`;
          } else if (priceDifference < 0) {
              const formattedPrice = formatPriceWithCurrency(Math.abs(priceDifference));
              formattedSuffix = ` ${suffix} (- ${formattedPrice})`;
          } else {
              formattedSuffix = ` ${suffix}`;
          }
          
          // Add the &nbsp;&nbsp;&nbsp;&nbsp; prefix and update the span
          const finalText = `&nbsp;&nbsp;&nbsp;&nbsp;${formattedSuffix}`;
          $titleSpan.html(finalText).attr('data-selected-swatch-value', finalText);
      }
    }

    // Function to update legend spans for all selected options
    function updateAllSelectedOptionSpans() {
        $('.cstm_rack_configure_wrapper_details .cstm_rack_configure_prd_variants.is-active fieldset').each(function() {
            const $fieldset = $(this);
            const $checkedInput = $fieldset.find('input[type="radio"]:checked');
            
            if ($checkedInput.length) {
                const optionValue = $checkedInput.val();
                const $legend = $fieldset.find('legend');
                const legendText = $legend.text().split(':')[0].trim();
                $legend.html(`${legendText}: <span data-selected-swatch-value="">${optionValue}</span>`);
            }
        });
    }

    function formatPriceWithCurrency(priceInCents) {
        // Try to get currency format from the base price element (like your updateTotalPriceAndButton function does)
        const $basePriceElement = $('.cstm_rack_configure_main_prd_variants span');
        
        if ($basePriceElement.length) {
            const basePriceText = $basePriceElement.text().trim();
            
            // Extract currency symbol and formatting from base price
            const currencyMatch = basePriceText.match(/^[^\d]+/);
            let currencyPrefix = '';
            let thousandSeparator = ',';
            
            if (currencyMatch) {
                currencyPrefix = currencyMatch[0].trim() + ' ';
            }
            
            // Check if base price has thousand separators
            if (!basePriceText.includes(',')) {
                thousandSeparator = '';
            }
            
            // Convert price from cents to dollars
            const priceInDollars = priceInCents / 100;
            
            // Format the number
            let formattedPrice = priceInDollars.toFixed(2);
            
            // Add thousand separators if needed
            if (thousandSeparator) {
                const parts = formattedPrice.split('.');
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
                formattedPrice = parts.join('.');
            }
            
            // Return with currency symbol
            return `${currencyPrefix}${formattedPrice}`;
        } else {
            // Default USD formatting if no base price element found
            const priceInDollars = priceInCents / 100;
            return `+ $${priceInDollars.toFixed(2)}`;
        }
    }


   }
  
});






document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.cstm_rack_configure_wrapper_details');
  const closeBtn = document.querySelector('.cstm_rack_configure_wrapper_details_close_icon');
  const overlay = document.querySelector('.cstm_rack_popup_overlay');

  // Close popup function
  function closePopup() {
    popup.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Close icon click
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  // Clicking overlay closes popup
  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }

  // Apply styling button click (supports multiple buttons)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.apply-styling-btn')) {
      closePopup();
    }
  });

  // Watch for popup activation to show overlay
  const observer = new MutationObserver(() => {
    if (popup.classList.contains('active')) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  });

  observer.observe(popup, {
    attributes: true,
    attributeFilter: ['class']
  });
});
